// extracted by mini-css-extract-plugin
export default {"light":"Profile_light__Xd6GY","profile":"Profile_profile__0eIvY","dark":"Profile_dark__ynN0F","prod":"Profile_prod__zEvHx","dev":"Profile_dev__uLBZO","bas":"Profile_bas__QTloJ"};